import React from 'react';
import cn from 'classnames';
import footerPattern from './assets/footerPattern.svg';
import styles from './footerPattern.module.scss';

interface IProps {
  className?: string,
}

const FooterPattern = ({ className }: IProps) => (
  <div className={ cn(styles.footerPattern, className) }>
    <img src={ footerPattern.src } />
  </div>
);

export default FooterPattern;
